import { Dispatch, ThunkAction } from '../../../../types/actions';
import { IGetState } from '../../../../types/types';
import { IComment } from '../../../../store/model/card/types/IComment';
import { markChatAsReadRest } from 'app/rest/effects/chats/chat/api/markChatAsReadRest';
import { getChat } from '../../../../view/react_components/main/chatView/store/chatView/selectors/getChat';
import { chatUpdateAction } from '../../../../view/react_components/main/chatView/store/chatView/actions/chatUpdateAction';
import { updateAction as cUpdateAction } from '../../../../view/react_components/main/chatView/store/chat/actions/updateAction';
import { chatGroupUpdateAction } from '../../../../view/react_components/main/chatView/store/chatView/actions/chatGroupUpdateAction';
import { updateAction as gUpdateAction } from '../../../../view/react_components/main/chatView/store/chatGroup/actions/updateAction';
import { IRestChat, TChatId } from 'app/types/rest/IRestChat';
import { updateStoreChat } from 'app/rest/effects/chats/chat/updateStoreChat';
import { getChatGroup } from 'app/view/react_components/main/chatView/store/chatView/selectors/getChatGroup';

//TODO done
export const chatLastCommentSeenUpdate = (
    chatId: TChatId,
    comment: IComment
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const chatForRollback = getChat(getState(), chatId);
        if (chatForRollback && !chatForRollback.newCommentCount) {
            return;
        }
        const chatGroupForRollback = getChatGroup(getState(), chatForRollback?.chatGroupId);
        return dispatch(markChatAsReadRest(chatId, comment))
            .then((chat: IRestChat)=>{
                return dispatch(updateStoreChat(chat));
            }).catch(() => {
                if (chatForRollback) {
                    dispatch(chatUpdateAction(chatId, cUpdateAction(chatForRollback)));
                }
                if (chatGroupForRollback) {
                    dispatch(chatGroupUpdateAction(chatGroupForRollback.id, gUpdateAction(chatGroupForRollback)));
                }
            });
    };
    return action;
};
